import {dateField, EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class AccountInvoiceData extends EntityData<AccountInvoiceData> {
    @identifier chargeId: number;
    @field RECEIPTNO: string;
    @field ACCOUNTNO: string;
    @field ACCOUNTNAME: string;
    @field BILLINGCYCLE: string;
    @field TERMS: number;
    @field TERMSCOMMENT: string;
    @dateField DUEDATE: Date;
    @field HEADER: string;
    @field FOOTER: string;
    @field CREDITFOOTER: string;
}
